import React, { useEffect, useState } from 'react';
import { outcomeSpecsApi } from '../utils/api';

// PRD-022 WU-E — read-only locked Outcome Spec on the Agreement page. Renders
// ALL FIVE blocks carried over from the Proposal (definition, success_criteria,
// required_artifacts, verification_method, exclusions) as a clean 2-column grid,
// matching agreement-unified-grid-v3.html. Empty optional blocks render
// "None specified." The spec is locked at spec_version 1 (immutable).

const BLOCK_DEFS = [
  ['definition', 'Definition'],
  ['success_criteria', 'Success criteria'],
  ['required_artifacts', 'Required artifacts'],
  ['verification_method', 'Verification method'],
  ['exclusions', 'Exclusions'],
];

export default function OutcomeSpecPanel({ agreementId, deliverableId }) {
  const [blocks, setBlocks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true); setMissing(false);
      try {
        const res = await outcomeSpecsApi.getAgreementSpec(agreementId, deliverableId);
        if (cancelled) return;
        setBlocks(res.data.spec?.blocks || []);
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) setMissing(true);
        else setMissing(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [agreementId, deliverableId]);

  if (loading) return <div className="text-xs text-gray-600 italic">Loading spec…</div>;
  if (missing || !blocks) return <div className="text-xs text-gray-600 italic">No outcome spec for this deliverable.</div>;

  const byType = new Map(blocks.map((b) => [b.block_type, (b.content_markdown || '').trim()]));

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
      {BLOCK_DEFS.map(([type, label], i) => {
        const content = byType.get(type);
        const empty = !content;
        return (
          <div key={type} className={`grid grid-cols-[168px_1fr] ${i < BLOCK_DEFS.length - 1 ? 'border-b border-gray-100' : ''}`}>
            <div className="bg-slate-50 px-3 py-2.5 text-[10px] font-extrabold uppercase tracking-wide text-gray-600 border-r border-gray-100">{label}</div>
            <div className={`px-3 py-2.5 text-[12.5px] ${empty ? 'text-gray-600 italic' : 'text-gray-700'}`}>
              {empty ? 'None specified.' : content}
            </div>
          </div>
        );
      })}
    </div>
  );
}
